import styled from 'styled-components';
import { Form } from '@unform/web';

export const Container = styled.div`
  margin: 10px 10px 10px 60px;
  background: ${({ theme }) => theme.colors.white};
  height: calc(100% - 60px);
  border: 1px solid ${({ theme }) => theme.colors.border};

  display: flex;
  flex-direction: column;

  label {
    font-size: 12px;
    color: ${({ theme }) => theme.colors.grey};
    opacity: 0.7;
  }

  input {
    padding-top: 10px;
    height: 30px;
    background: transparent;
    border-bottom: 1px solid ${({ theme }) => theme.colors.lightBorder};
  }

  h4 {
    margin-bottom: 16px;
    color: ${({ theme }) => theme.colors.blue};
  }

  section {
    margin-left: 16px;

    display: flex;
    align-items: center;

    & + section {
      margin-top: 16px;
    }

    div {
      display: flex;
      flex-direction: column;

      & + div {
        margin-left: 16px;
      }
    }
  }

  @media print {
    & {
      display: none;
    }
  }
`;

export const Header = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: ${({ theme }) => theme.colors.primary};
  background: ${({ theme }) => theme.colors.greyBackground};
  padding: 5px 10px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};

  div {
    display: flex;
    align-items: center;

    h1 {
      font-size: 16px;
      margin-left: 10px;
    }
  }

  button {
    background: transparent;
    border: none;
    transition: opacity 0.2s;

    &:hover {
      opacity: 0.7;
    }
  }
`;

export const Controls = styled.div`
  display: flex;
  padding: 5px 10px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
  align-items: center;

  button,
  a {
    display: flex;
    flex-direction: column;
    align-items: center;
    background: none;
    border: 0;
    transition: opacity 0.2s;

    & + button {
      margin-left: 16px;
    }

    & + a {
      margin-left: 16px;
    }

    &:hover {
      opacity: 0.7;
    }

    svg {
      font-size: 15px;
      margin-bottom: 3px;
      color: ${({ theme }) => theme.colors.primary};
    }

    span {
      font-size: 12px;
      color: ${({ theme }) => theme.colors.primary};
    }
  }

  div {
    margin-left: 16px;

    display: flex;
    align-items: center;
    justify-content: center;

    span {
      margin: 0 8px 0;
    }
  }

  .billets-counter {
    margin-left: auto;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    padding: 8px 16px;
    background: ${({ theme }) => theme.colors.greyBackground};
    border: 1px solid ${({ theme }) => theme.colors.border};
    border-radius: 4px;

    .counter-label {
      font-size: 12px;
      color: ${({ theme }) => theme.colors.grey};
      margin: 0;
      font-weight: 500;
    }

    .counter-value {
      font-size: 16px;
      color: ${({ theme }) => theme.colors.primary};
      margin: 0;
      font-weight: bold;
    }
  }
`;

export const Filter = styled(Form)`
  padding: 8px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};

  display: flex;
  align-items: center;
  justify-content: space-between;

  .name,
  .taxation_type {
    width: 20%;
  }

  .document_type,
  .situation,
  .monthly,
  .consistency,
  .client_type,
  .contract_type {
    width: 14%;
  }

  > div + div {
    margin-left: 16px;
  }

  button {
    border: 0;
    background: transparent;
    margin: 0 16px;
    transition: opacity 0.2s;
    width: 4%;

    &:hover {
      cursor: pointer;
      opacity: 0.8;
    }

    svg {
      color: ${({ theme }) => theme.colors.primary};
      height: 20px;
      width: 20px;
    }
  }

  .search-name {
    margin-left: 0px;

    span {
      position: absolute;
      margin-top: 18px;
      margin-left: -15px;
      font-size: 12px;
      font-weight: bold;
    }
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  table {
    thead th {
      background: ${({ theme }) => theme.colors.white};
      position: sticky;
      top: 0;
    }

    .active {
      padding-left: 8px;
      width: 30px;
      text-align: center;
    }

    .has-mp {
      /* coluna de like/dislike: mais estreita e centralizada */
      width: 36px;
      max-width: 36px;
      text-align: center;
      padding: 0 6px;
      vertical-align: middle;
    }

    .document {
      width: 145px;
    }

    .name {
      width: 25%;
      max-width: 0;
    }

    .city {
      width: 10%;
    }

    .group {
      width: 10%;
      max-width: 0;
    }

    .cei,
    .state_registration {
      width: 145px;
    }

    .client_type,
    .contract_type {
      width: 10%;
    }
    .billet-situations {
      width: 20%;
      max-width: 260px;
      word-break: break-word;
    }
    .mp-badge {
      display: inline-block;
      background: ${({ theme }) => theme.colors.success || '#006229'};
      color: #fff;
      padding: 2px 8px;
      border-radius: 12px;
      font-size: 11px;
      margin-left: 8px;
    }

    tr.inconsistent-row td {
      color: ${({ theme }) => theme.colors.danger || '#E53935'};
      font-weight: 700;
    }

    tr.inconsistent-row td span:not(.mp-badge),
    tr.inconsistent-row td div {
      color: inherit;
      font-weight: inherit;
    }

    tr.inconsistent-row .mp-badge {
      color: #fff;
      font-weight: 400;
    }
  }
`;

export const DetailsContainer = styled.div`
  padding: 10px;

  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const BasicInfo = styled.div`
  display: flex;
  flex-direction: column;

  .document_type,
  .situation {
    width: 10%;
  }

  .document,
  .client_type,
  .closing_tax {
    width: 15%;
  }

  .acquisition_type {
    width: 20%;
  }

  .nickname,
  .cei,
  .state_registration,
  .phone,
  .protocol_preference,
  .birthday,
  .contract_date,
  .start_day,
  .end_day,
  .tributes_payment {
    width: 25%;
  }

  .group {
    width: 50%;
  }

  .name {
    width: 60%;
  }

  .closing_tax {
    flex-direction: row-reverse;
    align-items: center;
    justify-content: flex-end;

    > input {
      margin-right: 16px;
      transform: scale(1.5);
    }
  }
`;

export const Addresses = styled.div`
  margin-top: 16px;

  display: flex;
  flex-direction: column;
`;

export const Address = styled.div`
  display: flex;
  flex-direction: column;

  & + div {
    margin-top: 16px;
  }

  .zipcode,
  .number,
  .type {
    width: 15%;
  }

  .street {
    width: 55%;
  }

  .complement,
  .neighborhood,
  .city,
  .state {
    width: 25%;
  }
`;

export const Contacts = styled.div`
  margin-top: 16px;

  display: flex;
  flex-direction: column;

  .contact_type {
    width: 25%;
  }

  .content {
    width: 75%;
  }
`;

export const RelatedList = styled.div`
  margin-top: 16px;

  display: flex;
  flex-direction: column;

  &.monthly-payments-list {
    .monthly-payment-item {
      display: flex;

      & + .monthly-payment-item {
        margin-top: 16px;
      }

      .monthly-payment-section {
        display: flex;
        align-items: center;
        width: 100%;
        padding: 0;
        border: none;
        background: transparent;
      }

      .mp-value {
        width: 10%;
        min-width: 120px;
        display: flex;
        flex-direction: column;
      }

      .mp-meta {
        display: flex;
        align-items: center;
        gap: 16px;
        flex: 1;
      }

      .mp-due,
      .mp-desc {
        flex: 1;
        display: flex;
        flex-direction: column;
      }
      .mp-actions {
        display: flex;
        align-items: center;
        margin-left: 12px;
      }
    }
  }
`;

export const Related = styled.div`
  display: flex;
  flex-direction: column;

  & + div {
    margin-top: 16px;
  }

  .related_name,
  .related_treatment_name,
  .related_email {
    width: 25%;
  }

  .related_birthday {
    width: 10%;
  }

  .related_document,
  .related_contact {
    width: 20%;
  }

  .dpt_tax,
  .dpt_labour,
  .dpt_accounting,
  .dpt_financial,
  .dpt_admin,
  .responsible {
    width: 16%;

    flex-direction: row-reverse;
    align-items: center;
    justify-content: flex-end;

    > input {
      margin-right: 16px;
      transform: scale(1.5);
    }
  }
`;

export const Tags = styled.div`
  margin-top: 16px;

  display: flex;
  flex-direction: column;

  .tag {
    width: 100%;
  }
`;

export const Audit = styled.div`
  margin-top: 16px;

  display: flex;
  flex-direction: column;

  .date,
  .user,
  .action {
    width: 33%;
  }
`;

export const Button = styled.button`
  // display: flex;
  // align-items: center;
  // justify-content: center;
  // width: max-content;

  // background: ${({ theme }) => theme.colors.success};
  // color: #fff;
  // border-radius: 5px;
  // padding: 10px 20px;
  // transition: background 0.3s;

  // &:hover {
  //   background: ${({ theme }) => theme.hover.success};
  // }

  // svg {
  //   margin-left: 10px;
  // }

  // &:disabled {
  //   cursor: no-drop;
  // }
`;

export const FormContainer = styled(Form)`
  display: flex;
  flex-direction: column;
  padding: 10px;
  // visibility: ${props => (props.loading ? 'hidden' : 'visible')};

  // h4 {
  //   margin-bottom: 16px;
  //   color: #44546a;
  // }

  // section {
  //   margin-left: 16px;
  //   color: ${({ theme }) => theme.colors.grey};

  //   display: flex;
  //   align-items: flex-end;

  //   & + section {
  //     margin-top: 16px;
  //   }
  // }
`;

// badge for monthly payments
export const MpBadge = styled.span`
  display: inline-block;
  background: ${({ theme }) => theme.colors.success || '#006229'};
  color: #fff;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 11px;
  margin-left: 8px;
`;
